module.exports = {
  "country": "DE",
  "artist": "Dschinghis Khan",
  "song": "Dschinghis Khan",
  "year": "1979",
  "place": "4",
  "spotify": "24g7Wa2aTohgmuJVP4Gxia"
};